import { useStore } from "@/stores/useStore.ts";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Spinner from "@/components/base/Spinner.tsx";
import { PageHeading } from "@/components/common/PageHeading.tsx";
import { Button } from "@/components/base/Button.tsx";
import { PencilIcon } from "lucide-react";
import { EditCompanySettingsForm } from "@/components/forms/EditCompanySettingsForm.tsx";
import { PatchTenantDto } from "@/models";
import { tenant as tenantActions } from "@/repositories/tenant";

export const CompanySettingsPage = () => {
  const tenant = useStore((s) => s.tenant);
  const user = useStore((s) => s.user);
  const tenantRole = useStore((s) => s.tenantRole);
  const navigate = useNavigate();
  const allowedTenants = useStore((s) => s.allowedTenants);
  const { tenantId } = useParams();

  const [isEditing, setIsEditing] = useState(false);

  console.log({ tenant, tenantId });

  const handleSave = (values: PatchTenantDto) => {
    return tenantActions
      .update(values.id, values)
      .then(() => setIsEditing(false));
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  useEffect(() => {
    if (allowedTenants && !allowedTenants.find((t) => t.id === tenantId)) {
      navigate("/");
    }
  }, [allowedTenants, tenantId, navigate]);

  if (!tenantId || !user) {
    return null;
  }

  if (tenantId !== tenant?.id) {
    return (
      <div className="flex flex-grow items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (tenantRole !== "admin" && tenantId !== "superAdmin") {
    return (
      <div className="flex flex-grow items-center justify-center">
        403 - FORBIDDEN
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 m-auto px-8 py-2">
      <div className="flex flex-row gap-4 justify-between">
        <PageHeading>{`${tenant.name}'s Settings`}</PageHeading>
        {!isEditing && (
          <Button onClick={() => setIsEditing(!isEditing)}>
            <PencilIcon />
          </Button>
        )}
      </div>
      <div>
        <EditCompanySettingsForm
          initialData={tenant}
          isEditable={isEditing}
          onSubmit={handleSave}
          onCancel={handleCancel}
        />
      </div>
    </div>
  );
};
